import template from './lead.popup.messenger.menu.html';

/**
 * Renders dropdown menu to choose the contact and messenger to use for chat
 */
export const messengerMenu: angular.IDirectiveFactory = () => ({
  restrict: 'A',
  controllerAs: 'vm',
  bindToController: true,
  controller() {},
  scope: {
    // string[]
    phones: '=',
    // {type: string; icon: string}[]
    messengers: '=',
    // (props: {phone: string, type: string}) => void
    onChange: '&',
    // (props: {phone: string, type: string}) => void
    isSelectedItem: '&',
  },
  template,
});
